import Vue from 'vue'
import Router from 'vue-router'
import staticRouter from "./staticRouter"

// 异步加载页面组件
const importPage = view => () =>
  import(/* webpackChunkName: "p-[request]" */ `@/components/${view}.vue`)

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  mode: 'history', // 去掉url中的#
  scrollBehavior: () => ({ y: 0 }),
  // routes: JSON.parse(JSON.stringify(staticRouter))
  routes: staticRouter
})


// WEBPACK FOOTER //
// ./src/router/index.js